import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
}

const ChevronRightIcon: React.FC<Props> = ({ className }) => {
  return (
    <SVGIcon viewBox="0 0 24 24" width="24" height="24" fill="none" className={className}>
      <path
        d="M9 5l7 7-7 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVGIcon>
  );
};

export default ChevronRightIcon;
